export const BOOSTERS_HELP_URL = 'https://help.rask.ai/hc/introducing-boosters';
